import axios from '@/libs/api.request'
//获取统计信息
export const staticData = data => {
    return axios.request({
      url: '/welcome/static-data',
      method: 'post',
      data
    })
  }
//获取日报/月报数据
export const kpiBus = data => {
    return axios.request({
      url: '/welcome/kpi-bus',
      method: 'post',
      data
    })
  }
//统计日数据
export const staticDailt = data => {
    return axios.request({
      url: '/welcome/static-dailt',
      method: 'post',
      data
    })
  }
//30天营业额数据
export const staticList = data => {
    return axios.request({
      url: '/welcome/static-list',
      method: 'post',
      data
    })
  }